// extracted by mini-css-extract-plugin
module.exports = {"m--copy-icon":"CopyIcon_m--copy-icon__NBOMU","rounded":"CopyIcon_rounded___ipkd"};